<template>

  <section class="Send__password__reset__email0010">
    <el-row :gutter="0" class="Send__password__reset__emailHead">
      <router-link to="/sp/0002" class="Router__To__Destination" tabindex="1">
        <i class="el-icon-close" tabindex="1"></i>
      </router-link>
      <el-col :span="6" class="whiteBg">
        <span class="Send__password__reset__emailSpan">パスワードリセットメール送信</span>
      </el-col>
      <el-col :span="12">
        <img src="../../assets/image/logo-new.png" alt="logo" class="ElnetLogo" />
      </el-col>
      <el-col :span="6"></el-col>
    </el-row>
    <el-row class="Send__password__reset__emailBody">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="企業コード">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="ユーザーID">
          <el-input v-model="form.name2"></el-input>
        </el-form-item>
        <el-button type="primary" plain class="inquiry__btn">送信</el-button>
        <el-button type="info" plain class="inquiry__btn">戻る</el-button>
      </el-form>
    </el-row>
  </section>

</template>

<script>
//import Common from '../../common/CommonFunc.js'
  export default  {
    name: 'Send__password__reset__email0010',
    props: [],
    mounted () {

    },
    data () {
      return {
        form: {
        name: "",
        name2: ""
      }
      }
    },
    methods: {

    },
    computed: {

    },
    beforeCreate(){
      //Common.Session.SP_CheckSessionExists_IfExpired_GoToLogout();
      //Common.Session.CheckIsMobile("/sp/0010","/0022"); // MobileScreen Path, WebScreen Path
   }
}


</script>
<style scoped>
 @import "0010.css";
 @import "../../assets/css/customStyle.css"; 
</style>